'use client'

import { Sparkles } from 'lucide-react'
import { useInView } from '@/hooks/useInView'

export function BlogHero({ postCount }: { postCount: number }) {
  const { ref, isInView } = useInView()

  return (
    <section className="relative overflow-hidden">
      {/* Gradient mesh background */}
      <div className="gradient-mesh-hero absolute inset-0 pointer-events-none" />

      {/* Content */}
      <div
        ref={ref}
        className="section-inner relative z-10 text-center pt-24 pb-16 md:pt-32 md:pb-20"
      >
        {/* Pill badge */}
        <div className={`flex justify-center mb-6 anim-fade-in-up anim-delay-1 ${isInView ? 'in-view' : ''}`}>
          <span className="inline-flex items-center gap-2 px-4 py-1.5 text-sm font-medium text-zinc-300 rounded-full border border-zinc-800 bg-zinc-900/60 backdrop-blur-sm">
            <Sparkles size={14} className="text-red-400" />
            📝 Latest insights
          </span>
        </div>

        {/* Heading */}
        <h1
          className={`text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold tracking-tight text-white mb-5 anim-fade-in-up anim-delay-2 ${isInView ? 'in-view' : ''}`}
        >
          The BuilderLync{' '}
          <span className="gradient-text-red">Blog</span>
        </h1>

        {/* Subtitle */}
        <p
          className={`text-base sm:text-lg text-zinc-400 max-w-2xl mx-auto mb-8 leading-relaxed anim-fade-in-up anim-delay-3 ${isInView ? 'in-view' : ''}`}
        >
          Expert guides, software reviews, and actionable tips to help roofing
          contractors grow their business.
        </p>

        {/* Post count */}
        <p
          className={`text-sm text-zinc-500 font-medium anim-fade-in-up anim-delay-4 ${isInView ? 'in-view' : ''}`}
        >
          <span className="inline-block text-red-400 font-semibold mr-1">
            {postCount}
          </span>
          articles and counting
        </p>
      </div>

      {/* Bottom fade */}
      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-zinc-950 to-transparent pointer-events-none" />
    </section>
  )
}
